import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, Layer, Text,
} from 'grommet';
import { useAppTheme } from '@Components/Context';
import { DatetimeCalendar } from '@Components/Control';
import { localAsset } from '@Helpers/asset';
import { formatISOStringDisplay } from '@Helpers/util';
import {
  StyledModalActivateButton,
} from './StyledProductFormComponent';
import { StyledSVG } from '../StyledSharedComponents';


const CalendarInput = ({
  small,
  handleFormValues,
  value = undefined,
  searchTypeKey = null,
  minStartDate = null,
  timeZone,
  setTimeZone,
  inputConfig = null,
  timeSelectOverride = false,
  showCloseButton = true,
  ...rest
}) => {
  const [showCalendar, setShowCalendar] = React.useState(false);
  const { theme: { page, button } } = useAppTheme();
  let withTimeSelect = inputConfig?.format && searchTypeKey
    && inputConfig.format[searchTypeKey]
    && (inputConfig.format[searchTypeKey].optionalTime === true);

  if (timeSelectOverride || inputConfig?.format?.withTimeSelect === true) {
    withTimeSelect = true;
  }

  const displayValue = value ? formatISOStringDisplay(value, withTimeSelect, timeZone) : '';

  return (
    <Box>
      <StyledModalActivateButton
        plain
        modalOpen={showCalendar}
        highlight={page.focusHighlight}
        borderColor={page.inputBorder}
        textSize="1rem"
        onClick={() => setShowCalendar(true)}
        label={(
          <Box wrap={false} direction="row" justify="between" align="center" pad={{ right: '0.15rem' }}>
            <Text size="0.8rem" color={page.primaryText}>
              {value ? displayValue : 'Select a date'}
            </Text>
            <StyledSVG
              src={localAsset('images/calendar-icon.svg')}
              height="18px"
              width="18px"
              style={{ paddingTop: '0.15rem' }}
              $fillColor={button.iconColor}
            />
          </Box>
        )}
      />
      {showCalendar && (
        <Layer
          responsive={false}
          animate={false}
          onEsc={() => setShowCalendar(false)}
        >
          <DatetimeCalendar
            small={small}
            calendarMode="single"
            setDate={(val) => handleFormValues(val)}
            handleClose={() => setShowCalendar(false)}
            minStartDate={minStartDate}
            timeZone={timeZone}
            setTimeZone={setTimeZone}
            dateValue={value}
            showTimeSelect={withTimeSelect}
            showCloseButton={showCloseButton}
            {...rest}
          />
        </Layer>
      )}
    </Box>
  );
};

CalendarInput.propTypes = {
  small: PropTypes.bool.isRequired,
  inputConfig: PropTypes.shape({
    format: PropTypes.shape({
      sports: PropTypes.shape({
        optionalTime: PropTypes.bool,
      }),
    }),
  }),
  searchTypeKey: PropTypes.string,
  handleFormValues: PropTypes.func.isRequired,
  minStartDate: PropTypes.instanceOf(Date),
  timeZone: PropTypes.string.isRequired,
  setTimeZone: PropTypes.func.isRequired,
  value: PropTypes.string,
  timeSelectOverride: PropTypes.bool,
  showCloseButton: PropTypes.bool,
};

export default CalendarInput;
